import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import IdeaProjects from '../molecules/IdeaProjects/IdeaProjects'
import BusinessComponent from '../molecules/BusinessComponent/BusinessComponent'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import ChooseUs from '../molecules/ChooseUs/ChooseUs'
import ReliabilityIOSSteps from '../molecules/ReliabilityIOSSteps/ReliabilityIOSSteps'
import { getPageData, useData } from '../../app/helper/functions'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import images from '../../app/utlis/image'

const IosPage = () => {
    const { loading, data, error } = useData();
    const iosData = getPageData(data, 'iosPage');

    // Create refs for scroll-triggered animations
    const headerRef = useRef(null);
    const descriptionRef = useRef(null);
    const bannerRef = useRef(null);

    // Use inView hooks for scroll animation triggers
    const isBannerInView = useInView(bannerRef, { once: false });
    const isHeaderInView = useInView(headerRef, { once: false, amount: 0.3 });
    const isDescriptionInView = useInView(descriptionRef, { once: false, amount: 0.3 });
    // Animation variants
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8 } }
    }

    const slideInFromLeft = {
        hidden: { x: -100, opacity: 0 },
        visible: { x: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
    }

    const slideInFromBottom = {
        hidden: { y: 100, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
    }
    return (
        <>
            <div className='overflow-x-hidden'>
                <div className='bg-ios-bg bg-center bg-cover bg-no-repeat'>
                    <motion.div
                        className='bg-black/60'
                        variants={fadeIn}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.3 }}
                    >
                        <div className='flex flex-col md:flex-row h-[700px] md:h-auto justify-between gap-6 px-4 md:pr-16 md:pl-0 pt-24 md:pt-52 pb-8 md:pb-4'>
                            <motion.div
                                ref={headerRef}
                                className='text-white flex flex-col gap-2 relative w-full md:w-[180%] pl-4 md:pl-[9%]'
                                variants={slideInFromLeft}
                                initial="hidden"
                                animate={isHeaderInView ? "visible" : "hidden"}
                            >
                                <motion.div
                                    className='uppercase font-bold text-3xl sm:text-5xl md:text-7xl'
                                    whileHover={{ scale: 1.02 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    {iosData.title}
                                </motion.div>
                                <motion.div
                                    ref={descriptionRef}
                                    className='font-medium text-lg sm:text-xl md:text-2xl mb-6 md:mb-0'
                                    variants={{
                                        hidden: { opacity: 0, y: 20 },
                                        visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 } }
                                    }}
                                    initial="hidden"
                                    animate={isDescriptionInView ? "visible" : "hidden"}
                                >
                                    {iosData.description}
                                </motion.div>
                            </motion.div>
                            <motion.img
                                ref={bannerRef}
                                src={images.IOSBANNER}
                                className='w-[80%] mx-auto md:w-[40%]'
                                variants={slideInFromBottom}
                                initial="hidden"
                                animate={isBannerInView ? "visible" : "hidden"}
                                whileHover={{
                                    scale: 1.05,
                                    transition: { duration: 0.3 }
                                }}
                            />
                            <div className='h-[400px] w-[100px] '></div>
                        </div>
                    </motion.div>
                </div>

                <div className='bg-darkGreyPrimary'>
                    <ReliabilityIOSSteps iosData={iosData} />
                    <IdeaProjects iosData={iosData} />
                    <BusinessComponent />
                    <ProjectDisplay />
                    <AppsFaq />
                    <ChooseUs />
                    <DefaultFooter />
                </div>
            </div>
        </>
    )
}

export default IosPage
